import generatedSeedData from "./seedData.generated.json";

export const gestionSeedData = generatedSeedData;
